// src/ui/Loader.tsx
import { useProgress } from '@react-three/drei'
import { useEffect, useState } from 'react'

interface LoaderProps {
  onFinished?: () => void // Callback lorsque le chargement est fini
}

export function Loader({ onFinished }: LoaderProps) {
  const { progress } = useProgress()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (progress === 100) {
      const t = setTimeout(() => {
        setVisible(false)
        if (onFinished) onFinished()
      }, 500) // Petit délai pour que le chargement paraisse fluide
      return () => clearTimeout(t)
    }
  }, [progress, onFinished])

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f5f7f9',
      zIndex: 2000,
    }}>
      {/* LOGO PULSANT */}
      <img
        src={`${process.env.PUBLIC_URL}/images/ViZmeraldLoader.svg`}
        alt="ViZmerald loading"
        style={{
          width: '120px',
          height: '120px',
          marginBottom: '20px',
          animation: 'pulse 1.5s infinite ease-in-out'
        }}
      />

      {/* BARRE DE PROGRESSION */}
      <div style={{
        width: '200px',
        height: '4px',
        background: 'rgba(0,0,0,0.1)',
        borderRadius: '2px',
        overflow: 'hidden'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: '#0d6efd',
          transition: 'width 0.3s ease'
        }} />
      </div>

      <p style={{
        marginTop: '10px',
        fontSize: '12px',
        opacity: 0.5,
        textTransform: 'uppercase',
        letterSpacing: '2px'
      }}>
        Chargement des modules {Math.round(progress)}%
      </p>

      {/* Animation pulsante du logo
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(1); opacity: 0.8; }
        }
      `}</style> */}
    </div>
  )
}
